import { CookieService } from "./cookie-service";

declare var ALLOWEDORIGIN: string;

export class HttpBaseService {
    static async get<T>(url: string, signal: AbortSignal | undefined = undefined): Promise<T> {
        return fetch(url, {
            method: 'GET',
            headers: this.setHeaders(),
            signal: signal
        })
        .then(response => this.handleResponse<T>(response))
        .catch(error => this.handleError(error));
    }

    static async post<T, B>(url: string, body: B, signal: AbortSignal| undefined = undefined): Promise<T> {
        return fetch(url, {
            method: 'POST',
            headers: this.setHeaders(),
            body: JSON.stringify(body),
            signal: signal
        })
        .then(response => this.handleResponse<T>(response))
        .catch(error => this.handleError(error));
    }

    static async put<T, B>(url: string, body: B): Promise<T> {
        return fetch(url, {
            method: 'PUT',
            headers: this.setHeaders(),
            body: JSON.stringify(body)
        })
        .then(response => this.handleResponse<T>(response))
        .catch(error => this.handleError(error));
    }

    static async delete<T>(url: string): Promise<T> {
        return fetch(url, {
            method: 'DELETE',
            headers: this.setHeaders(),
        })
        .then(response => this.handleResponse<T>(response))
        .catch(error => this.handleError(error));
    }

    private static async handleResponse<T>(response: Response): Promise<T> {
        if (!response.ok) {
            const error = await response.json();
            return Promise.reject(error);
        }
        return response.json();
    }

    private static handleError(error: any): never {
        //console.error('HTTP Error:', error);
        throw error;
    }

    public static setHeaders() {
        let headers = {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'Access-Control-Allow-Origin': ALLOWEDORIGIN
        };

        let token = CookieService.getCookie('SRP');
        if (token) {
            headers['SRP'] = token;
        }

        let locale = CookieService.getCookie('srp-local');
        if (locale) {
            headers['srp-local'] = locale;
        }

        return headers;
    }
}